import { Tab, Tabs } from "@mui/material";
import { Typography } from "components/parts/Typography/Typography";
import { fontSize } from "constants/fontSize";
import { newColors } from "constants/newColors";
import styled from "styled-components";
import { InterviewType } from "types/graphqlapi";

export const StyledInterviewList = styled.div`
  min-height: 70px;
  height: 100%;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const StyledNodataTypography = styled(Typography)`
  display: flex;
  padding: 1rem;
`;

export const StyledTabs = styled(Tabs)`
  display: flex;
  width: 100%;
  border-bottom: solid 1px ${newColors.border};
  color: ${newColors.text};

  span {
    display: none;
  }

  button {
    padding-inline: 0.75em;
    font-size: ${fontSize.small};
  }

  button.Mui-selected {
    color: ${newColors.white};
    background-color: ${newColors.primary};
    border-radius: 5px 5px 0 0;
    transition-duration: 0.2s;
  }
`;

export const StyledTab = styled(Tab)`
  display: flex;
  flex-grow: 1;
  color: ${newColors.text};
  font-size: ${fontSize.small};
`;

export const StyledInterview = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 0.5rem 1rem 1.5rem;
  border-bottom: solid 1px ${newColors.border};
  cursor: pointer;

  :hover {
    background: ${newColors.hover};
  }
`;

export const StyledInterviewSeq = styled(Typography)`
  min-width: 1.5em;
`;

export const StyledInterviewTitle = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 0.5rem;
`;

export const StyledMonitorNameArea = styled.div`
  display: flex;
`;

export const StyledMonitorNameTypography = styled(Typography)<{
  interviewType?: InterviewType;
}>`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  width: ${({ interviewType }) =>
    interviewType === InterviewType.TERM ? "23em" : "14em"};
`;

export const StyledMemoTypography = styled(Typography)<{
  interviewType?: InterviewType;
}>`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  width: ${({ interviewType }) =>
    interviewType === InterviewType.TERM ? "23em" : "14em"};
`;

export const StyledTodayIndicator = styled.div`
  display: flex;
  width: 3em;
  height: 100%;
`;
export const StyledOnGoingIndicator = styled.div`
  display: flex;
  width: 5em;
  height: 100%;
`;

export const StyledTypography = styled(Typography)`
  display: flex;
  align-items: center;
  ::before {
    content: "";
    display: inline-block;
    background-color: ${newColors.active};
    width: 0.7em;
    height: 0.7em;
    border-radius: 50%;
    margin-right: 0.3em;
  }
`;
